<template>
  <div>
    <md-button @click="wxLogin">微信快速登录</md-button>

    <!-- 1、获取微信授权后回到此页面 -->
    <!-- 2、获取accessToken -->
    <!-- 3、通过accessToken获取微信用户信息 -->
    <!-- 4、判断是否存在登录状态 -->
    <!-- 5、无登录状态-使用unioid尝试登录 -->
    <!-- 6、如果无状态-使用接口 -->
    <md-tabbar :value.sync="active">
      <md-tabbar-item :key="1">账号登录绑定微信</md-tabbar-item>
      <md-tabbar-item :key="2">微信快速登录</md-tabbar-item>
    </md-tabbar>
    <div>
      <md-field
        v-model="mobile"
        label="手机号"
        placeholder="手机号"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-field
        v-model="password"
        label="密码"
        placeholder="密码"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
    </div>
    <!-- 1、微信快速注册 -->
    <!-- 2、账号登陆，绑定微信 -->
    <div class="mt-10 p-0-10" v-if="showMobile">
      <md-field
        v-model="mobile"
        label="手机号"
        placeholder="手机号"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-button @click="authRegister" class="mb-10">创建魔蓝账号</md-button>
      <md-button @click="authLogin">一键授权登录</md-button>
    </div>
    <div class="mt-10 p-0-10" v-if="showBind">
      <md-field
        v-model="mobile"
        label="手机号"
        placeholder="手机号"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-field
        v-model="password"
        label="密码"
        placeholder="密码"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-button @click="authBind">绑定魔蓝账号</md-button>
    </div>
    <div class="mt-10 p-0-10" v-if="showPassword">
      <md-field
        v-model="password"
        label="密码"
        placeholder="密码"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-field
        v-model="confirmPassword"
        label="确认密码"
        placeholder="确认密码"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-button @click="authChangePassword">确认修改密码</md-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { setItem, getItem, getQueryString } from '@/utils/comUtils'
import { ACCOUNT_BIND_TYPE } from '@/utils/constUtils'

import { mcToast } from '@/utils/mcSdkUtils'
export default {
  name: 'PageWechatIndex',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      active: 1,
      code: (this.$route.query || {}).code || getQueryString('code') || '',
      corpId:
        (this.$route.query || {}).corpId || getQueryString('corpId') || '',
      platformSource: (
        (this.$route.query || {}).platformSource ||
        getQueryString('platformSource') ||
        ''
      ).replace(/[^\d]+/gi, ''),
      mobile: '',
      wechatUserInfo: {},
      showMobile: false,
      showLoading: null,
      accessRes: {},
      showBind: false,
      showPassword: false,
      password: '',
      confirmPassword: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showLoading = this.$Toast({
      type: 'loading',
      content: '输入项目名称'
    })
    this.showLoading.show()
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    wxLogin() {},
    init() {
      const { code, corpId, platformSource } = this
      if (code) {
        const _accountId = (getItem('wechatUser') || {}).accountId
        if (_accountId) {
          setItem('platformSource', platformSource)
          window.location.href = `http://${window.location.host}/campusleave/home/?corpId=${corpId}&platformSource=${platformSource}`
        } else {
          // this.fetchUserOpenId(code)
          this.login(code)
        }
      }
      this.showLoading && this.showLoading.hide()
    },
    async login(code) {
      try {
        // 使用 code 获取微信授权 token
        // accessToken openid
        const accessRes = await API.getWechatAccessToken({ code })
        const { accessToken, openid } = accessRes
        this.accessRes = accessRes
        if (openid) {
          // 成功后使用token获取微信用户信息 昵称 unionid openid
          let _wechatUserInfo = await API.getWechatUserInfo({
            accessToken,
            openId: openid
          })
          console.log(`_wechatUserInfo----->`, _wechatUserInfo)
          this.wechatUserInfo = _wechatUserInfo
          setItem('unionid', _wechatUserInfo.unionid)
          setItem('wechatUserInfo', _wechatUserInfo)
          // 检测是否存在登录状态，如果存在就直接跳转首页
          let _token = await API.magicCheckLogin()
          if (_token) {
            // 已登录 重定向到选择校区机构页面
            // await this.methodUpdateTokenAndRedirect(_token)
            this.$router.push({
              name: 'PageHome'
            })
            console.log(`当前已登录, token未过期-->`, _token)
          } else {
            // 当前无登录状态
            // 通过 unionid 登录, 返回为空即无魔蓝账户, 提示注册
            let result = await API.magicLoginByUnionid({
              unionid: _wechatUserInfo.unionid
            })
            // 未注册 走注册接口
            if (!result) {
              this.showMobile = true
            } else {
              // 已注册 直接获取相关接口，走下一步
              let __res = await API.magicOrgList({
                accountId: result.accountId
              })
              console.log(`141__res-->`, __res)
              // 缓存用户信息
              setItem('wechatUser', {
                ..._wechatUserInfo,
                ..._wechatUserInfo.data,
                ...accessRes
              })
              // 跳转首页
              const { corpId, platformSource } = this
              window.location.href = `http://${window.location.host}/campusleave/?corpId=${corpId}&platformSource=${platformSource}`
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async authLogin() {
      let _token = await API.magicCheckLogin()
      if (_token) {
        // 已登录 重定向到选择校区机构页面
        // await this.methodUpdateTokenAndRedirect(_token)
        console.log(`当前已登录, token未过期-->`, _token)
      } else {
        // 当前无登录状态
        // 通过 unionid 登录, 返回为空即无魔蓝账户, 提示注册
        let result = await API.magicLoginByUnionid({
          unionid: this.wechatUserInfo.unionid
        })
        // 未注册 走注册接口
        if (!result) {
          this.showMobile = true
        } else {
          // 已注册 直接获取相关接口，走下一步
          let __res = await API.magicOrgList({
            accountId: result.accountId
          })
          console.log(`141__res-->`, __res)
          // 缓存用户信息
          setItem('wechatUser', {
            ...this.wechatUserInfo,
            ...this.wechatUserInfo.data,
            ...this.accessRes
          })
          // 跳转首页
          const { corpId, platformSource } = this
          window.location.href = `http://${window.location.host}/campusleave/?corpId=${corpId}&platformSource=${platformSource}`
        }
      }
    },
    async authRegister() {
      if (!this.mobile) {
        mcToast({
          msg: '请先输入手机号'
        })
        return
      }
      // 根据账号绑定信息查询账号信息
      const res = await API.getAccountSimpleness({
        bindType: ACCOUNT_BIND_TYPE.mobile,
        bindValue: this.mobile
      })
      console.log(`getAccountSimpleness->`, res)
      if ((res || {}).accountId) {
        mcToast({
          msg: '该账号已存在，请直接绑定'
        })
        this.wechatUserInfo.accountId = (res || {}).accountId
        this.showBind = true
      } else if (res.result === 'ME01010251002') {
        // 如果不存在，通过 unionId 创建一个魔蓝账号
        // const register = await API.magicRegister({
        //   unionId: this.wechatUserInfo.unionid,
        //   mobile: this.mobile
        // })
        // console.log(`magicRegister-->`, register)
        // 引导创建账号
        this.showPassword = true
      }
    },
    // 确认修改密码
    async authChangePassword() {
      const register = await API.createAccountRegister({
        password: this.password,
        unionId: this.wechatUserInfo.unionid,
        mobile: this.mobile,
        registerType: ACCOUNT_BIND_TYPE.weixinUid,
        registerValue: this.wechatUserInfo.unionid,
        name: this.wechatUserInfo.nickname,
        needCodeFlag: false,
        bindValue: this.mobile,
        bindType: 4,
        checkCode: ''
      })
      console.log(`magicRegister-->`, register)
    },
    authBind() {
      // 授权绑定魔蓝账号
      API.accountBind({
        bindValue: this.wechatUserInfo.unionid,
        bindType: ACCOUNT_BIND_TYPE.weixinUid,
        password: this.password,
        accountId: this.wechatUserInfo.accountId
      })
    },
    // 获取微信授权
    weChatAuthorization(code) {
      return new Promise((resolve, reject) => {
        API.getWechatAccessToken({ code })
          .then(res => {
            if (res.openid) {
              resolve(res)
            } else {
              mcToast({ msg: '登录失败' })
              reject(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 检测是否拥有魔蓝账号：如果拥有魔蓝账号，接口会返回 accountId，否则调用 registerMagicAccount 自动注册并登录魔蓝账号
    checkMagicAccount() {
      return new Promise((resolve, reject) => {
        API.getWechatAccessToken({})
          .then(res => {
            if (res.openid) {
              resolve(res)
            } else {
              mcToast({ msg: '登录失败' })
              reject(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 使用 unionId + mobile 注册魔蓝账号
    registerMagicAccount() {},
    // 使用 accountId + mobile 登录魔蓝
    loginMagicAccount() {}
  }
}
</script>

<style scoped></style>
